import type { ArticlesList } from '@swf/help';

import type { HelpCenterSearchWidgetState } from './types';

export const defaultState: HelpCenterSearchWidgetState = {
  isLoading: true,
  preloaded: false,
  categories: [],
  searchList: {} as ArticlesList,
  pageSize: '10',
  error: false
};
